export const defaultKeyValue = {
  "topic": "TestTopic",
  "key": {
    "test": "value"
  },
  "value": {
    "Id": 1234,
    "Name": "ABC",
    "ModifiedBy": "XYZ"
  }
}
